import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmPopupComponent } from './confirm-popup.component';
import { ButtonModule } from 'primeng/button';



@NgModule({
  declarations: [
    ConfirmPopupComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
  ],
  exports: [
    ConfirmPopupComponent
  ]
})
export class ConfirmPopupModule { }
